module.exports = __webpack_public_path__ + "static/media/waterfallsIcon.f6989663.svg";